import rollbar from 'rollbar';

const rollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  enabled: ['qa', 'prod'].includes(process.env.REACT_APP_ENV),
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.REACT_APP_ENV,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.REACT_APP_VERSION,
        guess_uncaught_frames: true,
      },
    },
  },
  ignoredMessages: [
    'Request failed with status code 401',
    'Request failed with status code 403',
    'Request failed with status code 404',
  ],
};

export default rollbar.init(rollbarConfig);
